export function getHasApplicantsBoardColumnTotal(total) {
  return total > 0
}
